/**
 * @ngdoc controller
 * @name userMaintenanceModule.ViewUserController
 * @description This controller is used for user maintenance module. This mainly
 *              deals with viewing the individual user details.
 * @requires userService is the service which is being used to interact with
 *           REST
 * @requires $scope,$stateParams for storing/passing information in scope/state
 * @requires $log mainly used for logging. Used only $log.debug and could be
 *           enabled/disabled based on need.
 * @requires $state for state routing
 */


angular.module('userMaintenanceModule').controller(
  'ViewUserController',
  [
    '$scope',
    '$log',
    '$state',
    '$stateParams',
    'userService',
    '$sessionStorage',
    function($scope, $log, $state, $stateParams, userService,
      $sessionStorage) {


      $scope.userId = $stateParams.userId;
      $scope.userType = $stateParams.userType;
      $scope.userUuid = $stateParams.breadCrumbDetails[1].userUuid;
      if($scope.userType === 'AG') {
        $scope.groupId = $sessionStorage.groupId;
      } else {
        $scope.groupId = $stateParams.groupId;
      }
      $scope.groupName = $stateParams.breadCrumbDetails[0];

      userService.getUserDetails($scope.userUuid, $scope.userType,
          $scope.groupId, ['SHID', 'GM'])
      .then(function(response) {
        $log.debug('success user view');
        $scope.viewUserDetails = response.data;
        $scope.viewUserDetails.blockGroupEmail = 'N';
        $scope.viewUserDetails.isGmAdmin = 'N';
        $scope.viewUserDetails.hasGm = 'N';
        $scope.viewUserDetails.hasSid = 'N';
        $scope.viewUserDetails.gmStatus = 'Disabled';
        $scope.viewUserDetails.sidStatus = 'Disabled';

        // Iterate through userRoles to set specific values
        response.data.userRoles.forEach((role) => {
          if (role.userGroupProductCode === 'GM') {
            $scope.viewUserDetails.blockGroupEmail  = role.blockGroupEmail === 'Y'
                ? 'Y' : 'N';
            $scope.viewUserDetails.isGmAdmin = role.isAdmin;
            $scope.viewUserDetails.hasGm = role.status
            === 'Enabled' ? 'Y' : 'N';
            $scope.viewUserDetails.gmStatus = role.status;
          }

          if (role.userGroupProductCode === 'SHID') {
            $scope.viewUserDetails.hasSid = role.status
            === 'Enabled' ? 'Y' : 'N';
            $scope.viewUserDetails.sidStatus = role.status;
          }

        });

        $scope.viewUserDetails.status = $scope.viewUserDetails.gmStatus ===
        'Enabled' ? 'Enabled' : $scope.viewUserDetails.sidStatus === 'Enabled'
            ? 'Enabled' : 'Disabled';

      }, function(error) {
        $log.debug(error);
      });



    }]);
